import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  FeatureNames,
  DhwHotWaterStorageTemperatureBottom,
  DhwHotWaterStorageTemperatureTop,
  FuelCellOperatingPhase,
  HeatingDhwProperties,
  Feature,
  FeaturePropertyKey,
  DcSensorValueProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-fuel-cell',
  templateUrl: './fuel-cell.component.html',
  styleUrls: ['./fuel-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FuelCellComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  storageTankSensorBottom$: Observable<Feature<DhwHotWaterStorageTemperatureBottom, never>>;
  storageTankSensorTop$: Observable<Feature<DhwHotWaterStorageTemperatureTop, never>>;
  volumetricFlowReturn$: Observable<Feature<DcSensorValueProperties, never>>;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  heatingDhw$: Observable<Feature<HeatingDhwProperties, never>>;
  powerOutput$: Observable<Feature<DcSensorValueProperties, never>>;
  fuelCellReturnTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  fuelCellSupplyTemperature$: Observable<Feature<DcSensorValueProperties, never>>;
  fuelCellOperatingPhase$: Observable<Feature<FuelCellOperatingPhase, never>>;

  @Input() deviceSelectId: string;
  @Input() deviceId: string;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.storageTankSensorBottom$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.storageTankSensorBottom,
      this.deviceId
    );
    this.storageTankSensorTop$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.storageTankSensorTop,
      this.deviceId
    );
    this.volumetricFlowReturn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.volumetricFlowReturn,
      this.deviceId
    );
    this.heatingDhw$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.dhw,
      this.deviceId
    );
    this.powerOutput$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.powerOutput,
      this.deviceId
    );
    this.fuelCellReturnTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.fuelCellReturnTemperature,
      this.deviceId
    );
    this.fuelCellSupplyTemperature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.fuelCellSupplyTemperature,
      this.deviceId
    );
    this.fuelCellOperatingPhase$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.fuelCellOperatingPhase,
      this.deviceId
    );
  }
}
